import * as urlUtils from 'utils/Url';


export function getPathUsers() {
  return `/users`;
}

export function getPathUserMemberships(userId, qs={}) {
  return urlUtils.appendQueryString(`/users/${userId}/memberships`, qs);
}

export function getPathAddUser() {
  return `/users/add`;
}

export function getPathEditUser(userId) {
  return `/users/${userId}/edit`;
}

export function getPathUserDetails() {
  return `/user-details`;
}

export function getPathEditUserDetails() {
  return `/user-details/edit`;
}

export function getPathAddUserDone() {
  return `/users/add/done`;
}

export function getPathChangeEmail() {
  return `/email/change`;
}

export function getPathChangePassword() {
  return `/password/change`;
}

export function getPathSetupUser() {
  return `/setup-user`;
}
